<template>
    <base-modal :modal-title="'Pivot Picker'" @close="close()" @save="save()">
        <FormulateForm>
            <table class="table table-noborder">
                <thead>
                    <tr><th>Field</th><th></th></tr>
                </thead>
                <tbody>
                    <tr v-for="pivot, ix in pivots">
                        <th>{{ pivot.field.name }}</th>
                        <td><FormulateInput type="button" label="Remove" @click="pivots.splice(ix, 1)" /></td>
                    </tr>
                    <tr>
                        <td>
                            <FormulateInput
                                type="select"
                                name="field"
                                v-model="pivotToAdd"
                                :options="availablePivots" />
                        </td>
                        <td>
                            <FormulateInput class="add" type="button" label="Add" @click="add" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </FormulateForm>
    </base-modal>
</template>


<script>
 var _ = require('lodash');

 import BaseModal from 'components/modals/BaseModal';

 export default {
     components: {
         BaseModal
     },
     props: {
         availableColumns: {
             type: Array
         },
         currentPivots: {
             type: Array
         }
     },
     computed: {
         used() {
             return new Set(_.map(this.pivots, (p) => { return (p.field.pk || p.field.id) }));
         },
         availablePivots() {
             var self = this;
             return this.availableColumns
                        .filter(function (item, index) {
                            return ((["TextField", "USStateField"].indexOf(item.data_type.id) > -1) || (item.data_type.type == 'custom')) && ('pk' in item) && (!self.used.has(item.pk));
                        })
                        .map(x => {
                            return {'id': x.pk || x.id, 'value': x, 'label': x.name};
                        });
         }
     },
     data() {
         return {
             pivotToAdd: null,
             pivots: []
         };
     },
     created () {
         this.pivots = _.map(_.cloneDeep(this.currentPivots),
                             function (x) { return { field: x.field }; });
     },
     methods: {
         add() {
             this.pivots.push({field: this.pivotToAdd});
             this.pivotToAdd = null;
         },
         close() {
             this.$emit('close');
         },
         save() {
             this.$emit('setPivots', this.pivots);
         }
     }
 }
</script>

<style scoped>
.modal-body {
  min-height: 40vh;
  background-color: #dedede;
}
.pre-scrollable {
  height: 35vh;
 }
</style>



// WEBPACK FOOTER //
// PivotPickerModal.vue?1962f1de